import React from "react";
import { Outlet } from "react-router-dom";

export default function HIS() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
